// extracted by mini-css-extract-plugin
export default {"wrapper":"Chicken_wrapper__uatjR","container":"Chicken_container__wAHB8","list":"Chicken_list__sThoo","products":"Chicken_products__Stw6q"};